// export default function formatDate(dateString) {
//     const dateParts = dateString?.split('T')[0]?.split('-');
//     const year = dateParts[0];
//     const month = dateParts[1];
//     const day = dateParts[2];

//     return `${day}/${month}/${year}`;
// }

export default function formatDate(dateString) {
  if (!dateString) return '';

  const isoDatePart = dateString.split('T')[0]; // "2025-06-13"
  const dateParts = isoDatePart.split('-');

  if (dateParts.length !== 3) return dateString; // Si no tiene formato esperado, devolvemos original

  const [year, month, day] = dateParts;

  return `${day}/${month}/${year}`;
}
